interface Reward {
  title?: string;
  amount: string;
}

const createReward = (friends: number, amount: number, isMax = false): Reward => ({
  title: isMax ? `${friends} amigos` : `${friends} ${friends === 1 ? 'amigo' : 'amigos'}`,
  amount: isMax ? `🎉 $${amount} 🎉` : `$${amount}`,
});

const createDots = (count: number): Reward[] => Array(count).fill({ amount: '.' });

export const friendsRewards = (
  amountByReferred: number,
  maxProfitThreshold: number,
  dotsCount = 7
): Reward[] => {
  const rewards: Reward[] = [
    createReward(1, amountByReferred),
    createReward(2, amountByReferred * 2),
    ...createDots(dotsCount),
    createReward(maxProfitThreshold, amountByReferred * maxProfitThreshold, true),
  ];

  return rewards;
};
